import { render, staticRenderFns } from "./RiskDialog.vue?vue&type=template&id=c67df0dc&scoped=true&"
import script from "./RiskDialog.vue?vue&type=script&lang=js&"
export * from "./RiskDialog.vue?vue&type=script&lang=js&"
import style0 from "./RiskDialog.vue?vue&type=style&index=0&id=c67df0dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67df0dc",
  null
  
)

export default component.exports